import { createRoute } from '@tanstack/react-router';
import { groupParentRoute } from 'pages/group/groupParentRoute';
import { pageResetMiddleWare, zodPage } from 'routes/routeUtils';
import { z } from 'zod';

export const groupGroupsLabsRoute = createRoute({
  getParentRoute: () => groupParentRoute,
  path: '/groups_labs',
  validateSearch: z.object({
    query: z.string().optional(),
    onlyPartners: z.boolean().default(true),
    page: zodPage,
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() =>
  import('pages/group/GroupsLabs/GroupGroupsLabsPage/GroupGroupsLabsPage').then((d) => d.Route)
);
